import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
  FetchTargetedCatalog,
  isTargetedCatalogLoaded,
  ITargetedCatalogApiResponse,
  targetedCatalogActionCreators,
  TargetedCatalogActionKeys
} from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { productsActionCreators } from '../../products';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { fetchTargetedCatalog } from '../targetedCatalogApi';

function* fetchTargetedCatalogSaga(action: FetchTargetedCatalog) {
  const isLoaded = yield select(isTargetedCatalogLoaded);

  if (!isLoaded) {
    // TODO figure out why the catalog isn't loading on render after first load
  }

  if (action.payload.full) {
    yield put(uiActionCreators.showFullPageLoading());
  } else {
    yield put(uiActionCreators.toggleLoading('targetedCatalog'));
  }
  const response: IApiExecuteRespone<ITargetedCatalogApiResponse> = yield call(fetchTargetedCatalog, action.payload);
  yield put(uiActionCreators.hideFullPageLoading());

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(targetedCatalogActionCreators.setCatalog(response.value));
    yield put(productsActionCreators.setProducts(response.value.items));
  }

  yield put(uiActionCreators.toggleLoading('targetedCatalog'));
}

export function* watchFetchTargetedCatalog() {
  yield takeEvery(TargetedCatalogActionKeys.FETCH_TARGETED_CATALOG, fetchTargetedCatalogSaga);
}
